import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { usePlausible } from 'next-plausible';
import {
    detectAiProvider,
    SeoAnalyticsEvents,
    trackAiReferralVisit
} from 'lib/seoAnalytics';

const sessionKey = 'tabextend-ai-referral-recorded';

export default function AiReferralTracker() {
    const router = useRouter();
    const plausible = usePlausible<SeoAnalyticsEvents>();
    const recordedRef = useRef(false);

    useEffect(() => {
        if (recordedRef.current) return;

        try {
            if (window.sessionStorage.getItem(sessionKey)) return;
        } catch (_error) {
            // Some privacy modes block session storage; analytics can still run once per mount.
        }

        const params = new URLSearchParams(window.location.search);
        const provider = detectAiProvider(
            document.referrer,
            params.get('utm_source') ?? ''
        );

        if (!provider) return;

        recordedRef.current = true;
        trackAiReferralVisit(plausible, {
            provider,
            landingPage: router.asPath
        });
        try {
            window.sessionStorage.setItem(sessionKey, 'true');
        } catch (_error) {
            // The in-memory guard still prevents duplicate events for this app mount.
        }
    }, [plausible, router.asPath]);

    return null;
}
